let cohort = "";

export const setCompanyListingCohort = (value) => {
  cohort = value == null ? "" : String(value);
};

export const getCompanyListingCohort = () => cohort;
